export default "__VITE_ASSET__Df6PgEBH__"